import PropTypes from 'prop-types'
import React, { Component } from 'react'

import MuseumForm from '../../museum/components/Form'
import ProgramForm from '../../program/components/Form'
import GuidedTourForm from '../../guided-tour/components/Form'

import connectToVersioning from '../connectors/connectToVersioning'

const forms = {
  museum: MuseumForm,
  program: ProgramForm,
  guidedTour: GuidedTourForm
}

const draftForms = {
  museum: connectToVersioning(MuseumForm),
  program: connectToVersioning(ProgramForm),
  guidedTour: connectToVersioning(GuidedTourForm)
}

export default class ReleaseForms extends Component {

  static propTypes = {
    draft: PropTypes.object,
    onChange: PropTypes.func,
    onSectionChange: PropTypes.func,
    onSubmit: PropTypes.func,
    section: PropTypes.string,
    steps: PropTypes.array,
    type: PropTypes.string,
    version: PropTypes.object,
  }

  renderVersion(Form) {

    const {
      section,
      type,
      version,
    } = this.props

    return (
      <div className={`${type} container-fluid`}>
        <form
          className="form form-horizontal vertical"
        >

          <Form
            section={section}
            current={version}
            validationObj={version.validFields}
            readOnly
            hideValidationErrors
          />

        </form>
      </div>
    )
  }

  renderNoVersion() {

    const { draft } = this.props

    if (draft.deletedAt) {
      return (
        <div className="empty-view default-empty-view">
          <div className="well well-lg">
            Dieses Objekt wurde vom Nutzer gelöscht. Das endgültige Löschen muss
            bestätigt oder abgelehnt werden.
            <br />
            <br />
            Zur Zeit erscheint dieses Objekt nicht auf www.musbi.de. Wird das Löschen
            bestätigt so wird das Objekt unwiederruflich entfernt. Wird es abgelehnt,
            so Erscheint das Objekt für den Nutzer wieder als deaktiviert.
          </div>
        </div>
      )
    }

    return (
      <div className="empty-view default-empty-view">
        <div className="well well-lg">
          Dieses Objekt ist noch nicht auf der Website veröffentlicht.
          Erst nach Freigabe der neuen Version (rechts) erscheint das
          Objekt auf
          {' '}
          <a href="http://www.musbi.de">http://www.musbi.de</a>
          .
          {/*<br />
        <br />
        <button
          className="btn btn-primary btn-large"
          style={{ visibility: 'hidden' }}
        >Jetzt erstellen!</button>*/}
        </div>
      </div>
    )
  }

  render() {

    const {
      draft,
      onChange,
      onSectionChange,
      onSubmit,
      section,
      steps,
      type,
      version,
    } = this.props

    const Form = forms[type]
    const DraftForm = draftForms[type]

    return (
      <div className="horizontal form-column-container scrollable">

        <div className="column-flex vertical">
          <div className="version-form vertical">
            <div className="vertical versions live">
              {version
                ? this.renderVersion(Form)
                : this.renderNoVersion()}
            </div>
          </div>
        </div>

        <div className="column-flex vertical">
          <div className="version-form vertical">
            <div className="vertical versions draft">
              <div className={`${type} container-fluid`}>
                <form
                  className="form form-horizontal vertical"
                  onSubmit={onSubmit}
                >

                  <DraftForm
                    section={section}
                    current={draft}
                    validationObj={draft.validFields}
                    onChange={onChange}
                    steps={steps}
                    goToSection={onSectionChange}
                    hideValidationErrors
                  />

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/release/components/ReleaseForms.js